// extracted by mini-css-extract-plugin
export var item = "nutsCartCard-module--item--zqApv";
export var xremove = "nutsCartCard-module--xremove--wTMjN";
export var image = "nutsCartCard-module--image--vnPOI";
export var remove = "nutsCartCard-module--remove--2Csss";
export var desc = "nutsCartCard-module--desc--JP92l";
export var count = "nutsCartCard-module--count--oyLVx";